var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"Hacker News: Job"}}),_c('PostList',{attrs:{"source":"https://hacker-news.firebaseio.com/v0/jobstories.json"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }